import Vue from 'vue';
import VueRouter from 'vue-router';
import LoginRoute from './modules/login';
import ScalesRoute from './modules/scales';
import ScalesByWeightRoute from './modules/scalesByWeight';
import HistoryRoute from './modules/history';
import EditScaleRoute from './modules/editScale';
import EditScalesByWeightRoute from './modules/editScalesByWeight';

Vue.use(VueRouter);

const AppRoute = [
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/:catchAll(.*)*',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...LoginRoute,
    ...ScalesRoute,
    ...ScalesByWeightRoute,
    ...HistoryRoute,
    ...EditScaleRoute,
    ...EditScalesByWeightRoute,
    ...AppRoute,
  ],
});

export default router;
